import {
  UPDATE_USER_PASSWORD,
  USER_PASSWORD_ERROR,
  LOADING_USER_PASSWORD,
} from '../types/PasswordTypes';
const initialState = {
  loading: false,
  error: false,
};

const passwordReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER_PASSWORD:
      return { ...state, loading: false, error: false };
    case USER_PASSWORD_ERROR:
      return { ...state, loading: false, error: true };
    case LOADING_USER_PASSWORD:
      return { ...state, loading: true, error: false };
    default:
      return state;
  }
};

export default passwordReducer;
